import { getTranslationLanguages } from '../deepl';

/**
 * @async
 * @param {DeepLOptions} options
 * @returns {*}
 */

export const handleDeepLFetch = async (options) => {
  try {
    const deepLlanguagesPromise = getTranslationLanguages(options);
    const deepLlanguagesResponse = await deepLlanguagesPromise;
    return deepLlanguagesResponse;
  } catch (e) {
    console.log(e); // eslint-disable-line no-console
    return undefined;
  }
};
